import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

import { withRouter, Redirect } from 'react-router-dom';

import { SortDirection } from 'react-virtualized';
import { CircularProgress } from 'react-md';
import { isEqual, isEmpty } from 'lodash-es';

import { CoogTable } from '@coog/react-components';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { theme } from '../../Theme/theme';
import { stringifyQuery, parseQuery } from '../../Utils/Utils';
import * as productsActions from '../../Services/Products/actions';
import FilterControls from '../../Components/Filter/FilterControls';

import { applyFilters } from './filters';

import { columns, filtersUI } from './config';

import './Products.scss';

class Products extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      redirectTo: undefined,
      list: undefined,
      filteredList: undefined,
      filters: props.filters,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromProps(nextProps, prevState) {
    const { list: nextList } = nextProps;
    const { list: prevList } = prevState;
    let newState = null;

    if (nextList && !!nextList.toJS && !Immutable.is(prevList, nextList)) {
      newState = {
        list: nextList, // TODO add filtering statement...
      };
    }

    return newState;
  }

  componentDidMount() {
    const self = this;
    const { actions, list, location, history, filters: defaultFilters } = self.props;
    actions.fetchCommercialProductsV2();
    const filters = isEmpty(parseQuery(location.search)) ? defaultFilters : parseQuery(location.search);
    self.setState({ filters });
    history.push({
      pathname: location.pathname,
      search: stringifyQuery(filters),
    });
    if (list) {
      self.filter({ list, ref: 'componentDidMount', filters });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const self = this;
    const { filters: prevFilters } = prevState;
    const { list, location } = self.props;
    //
    if (!Immutable.is(prevProps.list, list)) {
      if (typeof list !== 'undefined' && !Immutable.is(prevState.list !== list)) {
        self.filter({ list, ref: 'componentDidUpdate1' });
      }
    }
    // Filters
    const filters = prevFilters || parseQuery(location.search);
    if (typeof list !== 'undefined' && filters && !isEqual(prevFilters, filters)) {
      self.setState({ filters });
      self.filter({ list, ref: 'componentDidUpdate2' });
    }
  }

  handleFiltersChange = filters => {
    const { list, history, location } = this.props;
    history.push({
      pathname: location.pathname,
      search: stringifyQuery(filters),
    });
    this.setState({ filters });
    this.filter({ list, ref: 'handleFiltersChange', filters });
  };

  filter = ({ list, /* ref, */ filters: newFilters }) => {
    const { filters } = this.state;
    const filteredList = applyFilters({ list, filters: newFilters || filters });
    // eslint-disable-next-line react/no-did-update-set-state
    this.setState({ filteredList });
  };

  render() {
    const { redirect, redirectTo, ...state } = this.state;
    if (redirect) return <Redirect push to={redirectTo} />;

    const { list, filteredList, filters } = state;
    const { pageTitle, canonical, system, strings } = this.props;
    const helmet = (
      <Helmet
        htmlAttributes={{
          class: 'coog',
          lang: system.i18n.lang,
        }}
      >
        <meta charSet="utf-8" />
        <title>{strings[pageTitle] || 'Product'}</title>
        <meta name="description" content={strings[pageTitle] || 'Product'} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );

    const product = () =>
      list && filteredList ? (
        <MuiThemeProvider theme={theme}>
          <CoogTable
            defaultSorted={{ sortBy: 'rec_name', sortDirection: SortDirection.DESC }}
            rows={filteredList}
            columns={columns(this.handleAction, strings)}
            strings={strings}
            uid="id"
            onClickCellAction={this.handleAction}
          />
        </MuiThemeProvider>
      ) : (
        <CircularProgress id="products-loading" className="loading" />
      );

    return (
      <div className="coog-app products">
        {helmet}
        <div className="blocks-header">
          <h1 className="md-title md-cell md-cell--12">{strings[pageTitle] || ''}</h1>
        </div>
        {/* <Divider /> */}
        <div className="block-controls">
          {filteredList ? (
            <div className="block-info">
              <span className="value">{filteredList.size}</span>
              <span className="label">{strings['product.controls.info.label'] || 'product(s) find'}</span>
            </div>
          ) : undefined}
          <FilterControls
            id="products-filters-block"
            key="products-filters-block"
            strings={strings}
            filters={filters}
            onFiltersChange={this.handleFiltersChange}
            filtersUI={filtersUI({ strings })}
          />
        </div>
        <div className="md-body md-cell md-cell--12">{product()}</div>
      </div>
    );
  }
}

Products.propTypes = {
  pageTitle: PropTypes.string,
  canonical: PropTypes.string,
  // eslint-disable-next-line
  list: PropTypes.instanceOf(Immutable.List),
  // eslint-disable-next-line
  location: PropTypes.object.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line
  system: PropTypes.object,
  // eslint-disable-next-line
  filters: PropTypes.object,
};
Products.defaultProps = {
  pageTitle: 'title.product.list',
  canonical: 'http://www.coopengo.com/',
  strings: {},
  list: undefined,
  filters: {
    query: '',
    status: [],
    commercialProductId: [],
  },
};
// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => ({
  list: state.getIn(['products', 'list']),
  strings: state.toJS().products.strings,
  system: state.toJS().system,
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...productsActions }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Products));
